import { mapState, mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import { ja } from 'vuejs-datepicker/dist/locale'
import ApiManager from '@/utils/ApiManager'
import Loading from '@/components/Core/Loading'
// import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import LocationChart from './LocationChart'
import SpAppChart from './SpAppChart'

export default {
  name: 'DashBoard',
  components: {
    Datepicker,
    Loading,
    LocationChart,
    SpAppChart,
  },
  metaInfo () {
    this.setMeta({
      title: Constants.SiteInfo.title
      // meta: [
      //   { name: 'description', content: 'xxxxxxxxxx' },
      //   { name: 'keyword', content: 'xxxxxxxxxx' }
      // ]
    })
    return this.getMeta
  },
  data () {
    return {
      loading: true,
      loadingLocation: false,
      loadingSpApp: false,
      registerHash: Constants.RegisterHash,

      // テーブルオプション
      tableColumns: [
        'adminNoticeId',
        'createdAt',
        'targetServiceName',
        'title',
        'copyButton'
      ],
      tableData: [],
      tableOptions: {
        headings: {
          adminNoticeId: '通知ID',
          createdAt: '配信日時',
          targetServiceName: '配信先',
          title: 'タイトル',
          copyButton: ''
        },
        columnsClasses: {
          adminNoticeId: 'wp-5',
          createdAt: 'wp-15',
          targetServiceName: '',
          title: '',
          copyButton: 'wp-5'
        },
        sortable: [
          'adminNoticeId',
          'createdAt',
          'targetServiceName',
          'title'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts('お知らせ'),
        // perPage: Constants.TableOptions.perPage.view,
        perPage: Constants.TablePerPageInitial,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial,

      // 
      dateOptions: {
        ja: ja,
        typeable: false,
        disabledDates: {
          to: null,
          from: null
        }
      },
      inpLocationDate: '',
      locationModel: [],
      inpApAppDate: '',
      spAppModel: [],
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      dashboardModel: state => state.dashboard.dashboardModel,
      adminNoticeModel: state => state.dashboard.adminNoticeModel,
      // modal
      updatedList: state => state.dashboardRegistAdminNoticeModal.updated
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      isAdmin: 'auth/isAdmin',
      isOperator: 'auth/isOperator',
      userServiceUuid: 'auth/userServiceUuid',
      permittedView: 'permission/permittedView',
      permittedFunction: 'permission/permittedFunction',
      isSmartPhone: 'core/isSmartPhone'
    }),
    
    siteName () {
      return Constants.SiteInfo.name
    },

    // result
    resultService () {
      try {
        return this.dashboardModel.sysAdminDashboard.serviceCount
      // eslint-disable-next-line
      } catch (e) {
        return ''
      }
    },
    resultActive () {
      try {
        return Math.floor(this.dashboardModel.sysAdminDashboard.activiationRate  * 100) / 100
      // eslint-disable-next-line
      } catch (e) {
        return ''
      }
    },
    resultLocation () {
      try {
        return this.dashboardModel.sysAdminDashboard.locationCount
      // eslint-disable-next-line
      } catch (e) {
        return ''
      }
    },
    resultNotice () {
      try {
        return this.dashboardModel.sysAdminDashboard.noticeCount
      // eslint-disable-next-line
      } catch (e) {
        return ''
      }
    },

    // list
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },

    // enable
    showOverview () {
      return this.permittedFunction('Home', 'overview')
    },
    showAdminNotice () {
      return this.permittedFunction('Home', 'adminNotice')
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },

    // サービス運用者の表示
    operatorLocations() {
      return this.dashboardModel.serviceTandouDashboard.locationInfo.registeredLocationCount
    },
    operatorActiveLocations() {
      return this.dashboardModel.serviceTandouDashboard.locationInfo.activatedLocationCount;
    },
    operatorLinkedSpApp() {
      return this.dashboardModel.serviceTandouDashboard.spAppInfo.linkedSpCount;
    },
    operatorActiveLocationsMax() {
      console.log('@ this.operatorActiveLocations', this.operatorActiveLocations)
      return Math.max(10, Math.ceil(this.operatorActiveLocations / 10) * 10);
    },
    operatorLinkedSpAppMax() {
      return Math.max(10, Math.ceil(this.operatorLinkedSpApp / 10) * 10);
    },
  },
  watch: {
    updatedList: function (to) {
      if (!to) return
      // モーダルで対象配信タイプの変更がされたら一覧を更新
      this.init()
    }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      loadDashboardData: 'dashboard/loadDashboardData',
      showDashboardRegistAdminNoticeModal: 'dashboardRegistAdminNoticeModal/show',
      showDashboardConfirmAdminNoticeModal: 'dashboardConfirmAdminNoticeModal/show'
    }),
    init () {
      this.loading = true

      //TODO
      let dashboardParams = {}
      let adminNoticeParams = {}

      // データ読出し
      this.loadDashboardData({
        dashboardParams: dashboardParams,
        adminNoticeParams: adminNoticeParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.adminNoticeModel)

          if (this.isOperator) {
            console.log('model', this.dashboardModel.serviceTandouDashboard.locationInfo.locationActiveInfo.yearMonth);
            // const d = this.dashboardModel.serviceTandouDashboard.locationInfo.locationActiveInfo.yearMonth.replace(/年/g, '-').replace(/月/g, '') + '-01 00:00:01'
            const d = this.dashboardModel.serviceTandouDashboard.locationInfo.locationActiveInfo.yearMonth.split('年').join('/').split('月').join('') + '/01 00:00:01'
            console.log('replace', d);
            console.log('date obj', new Date(d));
            this.inpLocationDate = new Date(d)
            this.inpApAppDate = new Date(d)

            this.$set(this, 'locationModel', this.dashboardModel.serviceTandouDashboard.locationInfo.locationActiveInfo.dailyActiveInfo)
            this.$set(this, 'spAppModel', this.dashboardModel.serviceTandouDashboard.spAppInfo.spAppLaunchInfo.dailyLaunchInfo)
          }
        })
        .catch(error => {
          this.showError(error || null)
        })
    },
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      if (key === 'createdAt')
        return Utility.dateFormat(value, 'YYYY/MM/DD HH:mm')
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },
    
    changeFilters () {
      // this.loading = true

      // // メンター一覧を読出し
      // this.loadMentorList({
      //   MentorKbn: this.filterPerPage
      // })
      //   // eslint-disable-next-line
      //   .then(res => {
      //     this.loading = false
      //     this.tableData = $.extend(true, [], this.mentorModel)
      //   })
      //   .catch(error => {
      //     this.showError(error || null)
      //   })
    },

    registerItem () {
      this.showDashboardRegistAdminNoticeModal(Constants.RegisterHash)
    },
    detailItem (props) {
      this.showDashboardConfirmAdminNoticeModal(props.row.adminNoticeUuid)
    },
    copyItem (props) {
      console.log('copyItem', props);
      this.showDashboardRegistAdminNoticeModal(props.row.adminNoticeUuid)
    },

    changeLocationDate (value) {
      if (value === null) {
        // this.inpLocationDate = ''
        return
      }
      let dateObj = new Date(value)
      this.inpLocationDate = new Date(dateObj.setHours(0,0,0,1))

      this.loadingLocation = true

      let parameters = {
        activeYearMonth: moment(this.inpLocationDate).format('YYYYMM')
      }

      // 登録
      ApiManager.request(
        ['dashboard'],
        ['v1LocationActiveGraphGet'],
        [parameters])
        .then(res => {
          this.loadingLocation = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            this.$set(this, 'locationModel', res[0].data.locationActiveInfo.dailyActiveInfo)

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.loadingLocation = false
          this.showError(null)
        })
    },

    changeSpAppDate(value) {
      if (value === null) {
        // this.inpApAppDate = ''
        return
      }
      let dateObj = new Date(value)
      this.inpApAppDate = new Date(dateObj.setHours(0,0,0,1))

      this.loadingSpApp = true

      let parameters = {
        activeYearMonth: moment(this.inpApAppDate).format('YYYYMM')
      }

      // 登録
      ApiManager.request(
        ['dashboard'],
        ['v1SpAppLaunchGraphGet'],
        [parameters])
        .then(res => {
          console.log(res)
          this.loadingSpApp = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            this.$set(this, 'spAppModel', res[0].data.spAppLaunchInfo.dailyLaunchInfo)

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.loadingSpApp = false
          this.showError(null)
        })
    },
  }
}
